
export default {
    name: "Gamburger",
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        dark: {
            type: Boolean,
            default: false,
        },
    },
}
